import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { selectprocessedData } from "../../../features/importSlice";
import { signInUser } from "../../Utility/Auth";

// const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api";

const SelectCategoryImport = ({
  categories,
  categoryName,
  article_code,
  mcId,
}) => {
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState(null);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [matched, setMatched] = useState(true);
  const data = useSelector(state=>state.importReducer)

  // console.log('categories',categories, categoryName, article_code, mcId)

  useEffect(() => {
    try {
      const filtered = mcId
        ? categories?.filter(
            (element) =>
              String(element.mc?._id || element.mc) === String(mcId)
          )
        : categories;

      const sourceList =
        filtered && filtered.length > 0 ? filtered : categories;

      const options =
        sourceList?.map((element) => ({
          label: element.name,
          value: element._id,
        })) || [];

      setCategoryOptions(options);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching category:", error);
      setLoading(false);
    }
  }, [categories, mcId]);

  // console.log(categorys);

  useEffect(() => {
    const cleanCat = categoryName?.toString()?.trim()?.toLowerCase();
    let result = categories?.find(
      (item) => item?.name?.toString()?.trim()?.toLowerCase() === cleanCat
    );

    // If no direct name match, but mcId is provided and exactly 1 subcategory exists for that category
    if (!result && mcId) {
      const subCats = categories?.filter(
        (item) => String(item?.mc?._id || item?.mc) === String(mcId)
      );
      if (subCats?.length === 1) {
        result = subCats[0];
      }
    }

    const resultSelect = categoryOptions?.find(
      (item) =>
        item?.value === result?._id ||
        item?.label?.toString()?.trim()?.toLowerCase() === cleanCat ||
        item?.label?.toString()?.trim()?.toLowerCase() === result?.name?.toString()?.trim()?.toLowerCase()
    );

    if (result) {
      setMatched(true);
      const opt = resultSelect || { label: result.name, value: result._id };
      setSelectedOption(opt);
      setcategoryHandler({ id: result._id, name: result.name });
    } else {
      setMatched(false);
      setSelectedOption({
        label: "Select Sub Category",
        value: "",
      });
    }
  }, [categoryName, categoryOptions, mcId]);

  // Update Selected Value
  const setcategoryHandler = ({ id, name }) => {
    const current = data?.processedData?.find(
      (pro) => pro?.article_code === article_code
    );
    if (current && current.category === id && current.categoryName === name) {
      return;
    }
    const products = data?.processedData?.map((pro) =>
      pro?.article_code === article_code
        ? {
            ...pro,
            category: id,
            categoryName: name,
          }
        : pro
    );
    dispatch(selectprocessedData(products));
  };

  const handleSelectChange = (selected) => {
    // console.log("object selected", selected);
    setcategoryHandler({ id: selected.value, name: selected.label });
    setSelectedOption(selected);
    setMatched(true);
  };

  const customStyles = {
    singleValue: (provided, state) => ({
      ...provided,
      color: state.selectProps.matched ? "red" : "black", // Apply color based on 'matched'
    }),
    // Change the border color of the select box
    control: (provided, state) => ({
      ...provided,
      borderColor: state.selectProps.matched ? "red" : "gray", // Conditional border color
      boxShadow: state.isFocused ? "0 0 0 1px red" : "none",
      // "&:hover": {
      //   borderColor: state.selectProps.matched ? "red" : "gray",
      // },
    }),

    // Change the placeholder text color
    placeholder: (provided, state) => ({
      ...provided,
      color: state.selectProps.matched ? "red" : "gray", // Conditional placeholder color
    }),
  };

  return (
    <div>
      <Select
        styles={customStyles}
        matched={!matched}
        value={selectedOption}
        options={categoryOptions}
        placeholder={loading ? "Loading Categories..." : "Select category"}
        onChange={handleSelectChange}
        isSearchable
        classNamePrefix="react-select"
      />
    </div>
  );
};

export default SelectCategoryImport;
